<script setup>

</script>

<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-logo">
        <p style="color: #666666; font-size: 10px">Powered by</p>
        <img
          src="https://overmediacast-videos-sp.s3.sa-east-1.amazonaws.com/Logo_Brilho_Workverse.png"
          alt="Powered by Workverse"
        />
      </div>
    </div>
  </footer>
</template>
